import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 97 96"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M.8 48C1 20.8 23.1.2 48.8.3c27.3.2 47.9 22.6 47.6 48.2-.3 26.6-22.3 47.6-48.2 47.3C21.8 95.6.8 74.1.8 48Zm5.5.1c-.1 23.1 18.8 42.1 42.1 42.3 23.2.2 42.3-18.7 42.4-42C91 25 72.1 6 48.7 5.9 25.4 5.7 6.4 24.7 6.3 48.1Z" }, null, -1),
    _createElementVNode("path", { d: "M48.5 66.6H23.8c-1.2 0-2.1-.5-2.6-1.5-.5-.9-.4-1.8.1-2.7.6-1 1.6-1.3 2.7-1.3h49.2c2.3 0 3.6 1.9 2.9 3.8-.5 1.1-1.4 1.7-2.9 1.7H48.5ZM32.5 48.5a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4ZM64.7 48.5a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4Z" }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "SmileyRate3"}) } }